<template>
  <section>
    <div class="row">
      <div class="col-12 text-center">
        <img src="/static/img/general-infomation01.png" class="img-fluid">
      </div>
      <div class="col-12 text-center contact-header">
        ติดต่อเรา
      </div>
      <div class="col-12 text-center contact-content mt-2">
        <i class="fas fa-phone"></i>&nbsp;02-113-1138&nbsp;&nbsp;&nbsp;<span
        style="font-style: italic;">www.BeNeat.co</span>
      </div>
      <div class="col-12 text-center mt-4">
        <a href="https://line.me/R/ti/p/%40hnk7011n" target="_blank" style="margin: 1rem;" @click="trackLineEvent('Contact Line')">
          <img height="38" alt="Line BeNeat" src="/static/img/btn-line.png">
        </a>
        <a href="https://www.messenger.com/t/beneatco/" target="_blank" style="margin: 1rem;" @click="trackLineEvent('Contact FB msg')">
          <img height="38" alt="FB Messenger BeNeat" src="/static/img/btn-fb-messenger.png">
        </a>
      </div>
      <div class="col-12 text-center">
        <img src="/static/img/general-infomation02.png" class="img-fluid">
      </div>
      <div class="col-12 text-center contact-header mt-4">
        ติดต่อเรา
        <div class="separator"></div>
      </div>
      <div class="col-12 text-center contact-content mt-2">
        <i class="fas fa-phone"></i>&nbsp;02-113-1138&nbsp;&nbsp;&nbsp;<span
        style="font-style: italic;">www.BeNeat.co</span>
      </div>
      <div class="col-12 text-center mt-4">
        <a href="https://line.me/R/ti/p/%40hnk7011n" target="_blank" style="margin: 1rem;" @click="trackLineEvent('Contact Line')">
          <img height="38" alt="Line BeNeat" src="/static/img/btn-line.png">
        </a>
        <a href="https://www.messenger.com/t/beneatco/" target="_blank" style="margin: 1rem;" @click="trackLineEvent('Contact FB msg')">
          <img height="38" alt="FB Messenger BeNeat" src="/static/img/btn-fb-messenger.png">
        </a>
      </div>
      <div class="col-12 text-center contact-header" style="margin-top: 4rem;">
        Download Application
        <div class="separator"></div>
      </div>
      <div class="col-12 text-center" style="margin: 1rem 0 4rem 0;">
        <a href="https://itunes.apple.com/th/app/beneat/id1203611695?mt=8" target="_blank" style="margin: 0 1rem;">
          <img height="62" alt="BeNeat iOS App" src="/static/img/btn-app-store.svg">
        </a>&nbsp;
        <a href="https://play.google.com/store/apps/details?id=com.beneat.app" target="_blank" style="margin: 0 1rem;">
          <img height="62" alt="BeNeat Android App" src="/static/img/btn-play-store.svg">
        </a>
      </div>
    </div>
  </section>
</template>

<script>
  export default {
    methods: {
      trackLineEvent (type) {
        // Track Line Event
        let isFromLine = this.$cookies.get('isFromLine')
        if (isFromLine) {
          this.$lineTrack(type)
        }
      }
    },
    mounted () {
      let isFromLine = Number(this.$route.query.line)
      if (isFromLine === 1) {
        this.$cookies.set('isFromLine', true, '1d')
        // Track Line Event
        this.$lineTrack('Enter')
      }
    }
  }
</script>

<style scoped>
  [class*="col-"] {
    padding: 0;
  }

  .contact-header {
    font-size: 2rem;
  }

  .contact-content {
    font-size: 1.6rem;
  }

  .separator {
    display: block;
    height: 1px;
    border: 0;
    border-top: 1px solid #5cbfd6;
    margin: 0.5rem auto 1rem auto;
    padding: 0;
    width: 80%;
  }
</style>



// WEBPACK FOOTER //
// src/components/information/GeneralInformation.vue